import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import { AnyObject } from 'final-form';

interface IOfficeExpenseReportOptionsDialogProps {
    dialogName: string;
    handleOfficeExpenseReport?: (data: AnyObject) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    reportTypes?: Array<{ value: string | number, label: string }>;
    sortOptions?: Array<{ value: string | number, label: string }>;
    payPeriods?: Array<{value: number | string, label: string}>;
    offices?: Array<{value: number | string, label: string}>;
}

const OfficeExpenseReportOptionsDialog = (props: IOfficeExpenseReportOptionsDialogProps) => {
    const [payPeriods, setPayPeriods] = useState<Array<{value: number | string, label: string}>>(undefined);
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!props?.payPeriods) {
            setPayPeriods(props?.payPeriods);
        }
    }, [props?.payPeriods]);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const OKClicked = () => {
        let data = getValues();
        const payPeriod = payPeriods?.find(pp => pp.value === data?.reportOptions?.beginPeriod);
        const beginPeriod = payPeriod ? Number(payPeriod.label.replace('-', '').replace('(', '').replace(')', '')) : '';

        props?.handleOfficeExpenseReport({ payPeriod: beginPeriod, office: data?.reportOptions?.office });

        props.hideDialog();
    };

    return (
        <Dialog title="Report Options" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form style={{width: '85%'}}>
                    <RHFSelect
                        label="Report Type"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '8rem'}}
                        name={`reportOptions.reportType`}
                        options={!!props?.reportTypes ? props.reportTypes : [
                            { value: '1', label: 'Other Parameters - Invoice Date' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '90%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFSelect
                        label="Originating Office"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '4.5rem'}}
                        name={`reportOptions.office`}
                        options={!!props?.offices && props?.offices?.length > 0 ? props.offices : [
                            { value: '1', label: 'OK' },
                            { value: '2', label: 'TX' },
                            { value: '3', label: 'IH' }
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '70%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFSelect
                        label="Expense Source"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '5.8rem'}}
                        name={`reportOptions.wdFormat`}
                        options={[
                            { value: '1', label: 'A/P Voucher' },
                            { value: '2', label: 'A/P Voided Check' },
                            { value: '3', label: 'Credit Card' },
                            { value: '3', label: 'Manual Entry' }
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '90%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                    <RHFSelect
                        label="Beginning Period"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '5rem'}}
                        name={`reportOptions.beginPeriod`}
                        register={register}
                        errors={errors}
                        style={{ whiteSpace: 'nowrap', width: '100%' }}
                        options={payPeriods ? payPeriods : []}
                    />
                    <RHFSelect
                        label="Ending Period"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '6.8rem'}}
                        name={`reportOptions.endPeriod`}
                        register={register}
                        errors={errors}
                        style={{ whiteSpace: 'nowrap', width: '100%' }}
                        options={payPeriods ? payPeriods : []}
                    />
                    <RHFInputBox
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '6.45rem'}}
                        label="Client Number"
                        labelOnLeft={true}
                        name={`reportOptions.clientNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '70%' }}
                    />
                    <RHFInputBox
                        label="Project Number"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '5.7rem'}}
                        name={`reportOptions.projectNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '70%' }}
                    />
                    <RHFInputBox
                        label="Subcode Number"
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap', marginRight: '4.6rem'}}
                        name={`reportOptions.sectionNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '70%' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default OfficeExpenseReportOptionsDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/OfficeExpenseReportOptionsDialog.tsx